import RestApiBuilder from '@utils/RestApiBuilder'
import { ApiResponse, ApisauceInstance } from 'apisauce'
import parseFiltersIndicators from '@utils/parseFiltersIndicators'
import parseCustomDashboardFilters from '@utils/parseCustomDashboardFilters'
import { message } from 'antd'

const getMonthsBetween = (dateFrom?: string, dateTo?: string) => {
  //console.log(`meses entre ${dateFrom} y ${dateTo}`)

  if (dateFrom === undefined || dateTo === undefined) {
    return undefined
  }

  const from = new Date(dateFrom)
  const to = new Date(dateTo)

  const years = to.getFullYear() - from.getFullYear()
  const months = to.getMonth() - from.getMonth()

  // total de meses entre ambas fechas
  return years * 12 + months
}

/**
 * Expose all endponts for 'reports'.
 */
export default <T>(api: ApisauceInstance): ApiObject => ({
  ...RestApiBuilder<T>('reports', api),
  download: (reportName: string, filters: any, type) => {

    const finalFilters = {
      ...parseFiltersIndicators(filters),
      ...parseCustomDashboardFilters(filters),
    }

    //console.log('reports api download')
    //console.log(finalFilters)

    //@ts-ignore
    const semetreFilter = finalFilters?.responseValues?.['173003101'] ?? undefined

    const monthsBetween = getMonthsBetween(finalFilters.dateFrom, finalFilters.dateTo)
    //console.log(semetreFilter)
    if (monthsBetween !== undefined && monthsBetween > 12 && semetreFilter === undefined) {
      message.error("Debe elegir un rango de fechas menor o un custom filtro para el segmento de fechas.")
      return Promise.resolve({ ok: false, data: null } as ApiResponse<any, any>)
    }

    return api.post(`reports/${reportName}`,
      finalFilters,
      {
        responseType: 'blob',
        headers: {
          accept: type,
          //'content-type': type,
        },
      })
  },
})
